import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AuthScreen from './AuthScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requiredRole?: 'admin' | 'staff';
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true,
  requiredRole,
  redirectTo = '/login'
}) => {
  const { isAuthenticated, isLoading, user, login } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="app loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>システムを読み込み中...</p>
        </div>
      </div>
    );
  }

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // For SPA, we show the auth screen instead of redirecting
    return <AuthScreen onLogin={login} />;
  }

  // If a specific role is required, check user role
  if (requiredRole && user && user.role !== requiredRole) {
    // User doesn't have required role, redirect to home or show error
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If authentication is not required or user is authenticated with proper role
  return <>{children}</>;
};

export default ProtectedRoute;